<template>
  <h1 class="!text-2xl q:text-3xl font-bold font-titles text-highlight">
    <slot />
  </h1>
</template>
